<template>
  <div class="live-page">
    <van-nav-bar title="直播间" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back" />
      </template>
    </van-nav-bar>

    <div class="live-player-wrap">
      <video
        v-if="!notStarted"
        ref="liveVideo"
        class="live-video"
        controls
        muted
        autoplay
        preload="auto"
        crossorigin="anonymous"
        playsinline
        webkit-playsinline
      ></video>

      <div class="live-loading" v-if="loading">
        <van-loading type="spinner" color="#ff4ea3" />
      </div>

      <div class="live-empty" v-if="notStarted">
        <van-empty description="暂无权限观看直播" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      hlsPlayer: null,
      liveData: {},
      liveUrl: '',
      loading: true,
      notStarted: false
    };
  },
  methods: {
    back() {
      this.$router.push({ path: '/Home' });
    },
    getLiveUrl() {
      this.loading = true;
      this.notStarted = false;
      this.$http({
        method: 'get',
        url: 'video_get_live_url',
        data: { id: this.$route.query.id }
      }).then(res => {
        console.log('getLiveUrl', res);
        console.log('getLiveUrl data', res.data);
        const liveData = res.data || {};
        if (liveData.is_live === 0 || liveData.status === 0 || liveData.live_status === 0) {
          this.showNotStarted();
          return;
        }
        this.liveData = liveData;
        this.liveUrl = liveData.play_m3u8 || '';
        if (!this.liveUrl) {
          this.showNotStarted();
          return;
        }
        this.$nextTick(() => {
          this.initPlayer();
        });
      }).catch(err => {
        console.log('getLiveUrl error', err);
        this.showNotStarted();
      });
    },
    showNotStarted() {
      if (this.notStarted) {
        return;
      }
      this.loading = false;
      this.notStarted = true;
      this.destroyPlayer();
    },
    loadHlsScript() {
      if (window.Hls) {
        return Promise.resolve(window.Hls);
      }
      return new Promise((resolve, reject) => {
        const oldScript = document.getElementById('hlsjs-script');
        if (oldScript) {
          oldScript.onload = () => resolve(window.Hls);
          oldScript.onerror = reject;
          return;
        }
        const script = document.createElement('script');
        script.id = 'hlsjs-script';
        script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js';
        script.onload = () => resolve(window.Hls);
        script.onerror = reject;
        document.body.appendChild(script);
      });
    },
    initPlayer() {
      this.destroyPlayer();
      const video = this.$refs.liveVideo;
      if (!video) {
        return;
      }
      video.onplaying = () => {
        this.loading = false;
      };
      video.onloadedmetadata = () => {
        this.loading = false;
      };
      video.onerror = () => {
        console.log('live video error', video.error);
        this.showNotStarted();
      };

      this.initHlsPlayer(video);
    },
    initHlsPlayer(video) {
      this.liveUrl = this.liveData.play_m3u8 || this.liveUrl;
      this.loadHlsScript().then(Hls => {
        if (Hls && Hls.isSupported()) {
          this.hlsPlayer = new Hls({
            enableWorker: true,
            lowLatencyMode: true,
            liveSyncDurationCount: 3
          });
          this.hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
            console.log('hls error', event, data);
            if (data && data.fatal) {
              this.showNotStarted();
            }
          });
          this.hlsPlayer.loadSource(this.liveUrl);
          this.hlsPlayer.attachMedia(video);
          this.hlsPlayer.on(Hls.Events.MANIFEST_PARSED, () => {
            this.playVideo(video);
          });
          return;
        }

        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = this.liveUrl;
          video.load();
          this.playVideo(video);
          return;
        }

        this.showNotStarted();
      }).catch(err => {
        console.log('hls script load error', err);
        this.showNotStarted();
      });
    },
    playVideo(video) {
      const playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(err => {
          console.log('live play promise error', err);
          this.showNotStarted();
        });
      }
    },
    destroyPlayer() {
      if (this.hlsPlayer) {
        this.hlsPlayer.destroy();
        this.hlsPlayer = null;
      }
      if (this.$refs.liveVideo) {
        const video = this.$refs.liveVideo;
        video.onplaying = null;
        video.onloadedmetadata = null;
        video.onerror = null;
        video.removeAttribute('src');
        video.load();
      }
    }
  },
  mounted() {
    this.getLiveUrl();
  },
  beforeDestroy() {
    this.destroyPlayer();
  }
};
</script>

<style lang="less" scoped>
.live-page {
  min-height: 100vh;
  background: #29243d;
}

.nav-bar {
  background: linear-gradient(270deg, #323795, #4c206f);
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 32px;
}

.live-player-wrap {
  position: relative;
  width: 100%;
  height: calc(100vh - 46px);
  background: #000;
}

.live-video {
  display: block;
  width: 100%;
  height: 100%;
  background: #000;
  object-fit: contain;
}

.live-loading {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .35);
}

.live-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #29243d;
}

::v-deep .live-empty .van-empty__description {
  color: #d9c9ef;
  font-size: 28px;
}
</style>
